import React, { memo } from 'react';
import { Images } from '../../../../../../shared/app-constants';
import EmptyList from '../../../../../../shared/design-system/components/molecules/empty-list/empty-list';

interface CallLogsSearchEmptyStateProps {
  filterApplied?: boolean;
}

const CallLogsSearchEmptyState: React.FC<CallLogsSearchEmptyStateProps> = ({
  filterApplied = false,
}) => (
  <div className="call-logs-search-empty-state d-flex justify-content-center align-items-center">
    <EmptyList
      title={filterApplied ? 'No Result found' : 'No Search Result'}
      description={
        filterApplied
          ? "We can't find any data matching your filters."
          : "We can't find any data matching your search."
      }
      imgSrc={Images.NoResultCallLogs}
      isVertical
    />
  </div>
);

export default memo(CallLogsSearchEmptyState);
